import { render } from "./AcceptedOffer.vue?vue&type=template&id=2d10479c&scoped=true"
import script from "./AcceptedOffer.vue?vue&type=script&lang=js"
export * from "./AcceptedOffer.vue?vue&type=script&lang=js"

import "./AcceptedOffer.vue?vue&type=style&index=0&id=2d10479c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2d10479c"

export default script